// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('sales', {
        url: '/sales',
        parent: 'main',
        abstract: true,
        templateUrl: 'main/sales/sales.tpl.html',
        controller: 'MainSalesController as vm'
    });
}

// @ngInject
function MainSalesController() {
    var vm = this;
}

angular
    .module('main.sales', ['sales.api','sales.salestotal'])
    .config(stateConfig)
    .controller('MainSalesController', MainSalesController);
